import breakpoints from "../__utils/breakpoints";

const root = document.documentElement;

const pageNav = {
    pageNavWrapper: document.querySelector(".inpage-nav"),
    pageNavHeight: null,
    header: null,
    alertBarCloseBtn: null,
    headerHeight: null,
    topBorder: null,
    topBorderTopPosition: 0,
    pageNavList: null,
    pageNavLinks: null,
    setcionsWithId: null,
    activeClassName: "active",
    isInit: false,

    // To cache all elements
    cacheDOM() {
        this.header = root.querySelector("header.main-header");
        this.alertBarCloseBtn = root.querySelector(".alert-bar__close");
        this.pageNavList =
            this.pageNavWrapper.querySelector(".inpage-nav__list");
        this.pageNavLinks = [...this.pageNavList.querySelectorAll("a")];
        this.setcionsWithId = [
            ...root.querySelectorAll(
                ".single-tour-content div[id], section[id]"
            ),
        ];
        this.topBorder = this.pageNavWrapper.previousElementSibling;
    },

    // To add event listeners
    bindEventsListeners() {
        this.alertBarCloseBtn &&
            this.alertBarCloseBtn.addEventListener("click", () =>
                this.stickyPosition()
            );

        this.pageNavLinks.forEach((link) =>
            link.addEventListener("click", this.navLinkHandler)
        );
    },

    // Nav Link Click Handler
    navLinkHandler() {
        setTimeout(() => {
            pageNav.pageNavLinks.forEach((el) =>
                pageNav.setActiveClass(el, false)
            );
            pageNav.setActiveClass(this, true);
        }, 600);
    },

    // This method gets header's height value and sets it as page subnav position top. It is needed to make subnav sticky positioned when it gets under the header. It is fired in controller.js on init event and in this script on headers alert bar close button click event to recalculate headers height and respectively subnav's top position
    stickyPosition() {
        if (!this.pageNavWrapper || breakpoints.tabletMin.matches) {
            return;
        }
        this.headerHeight = this.header.getBoundingClientRect().height;
        this.header.classList.add("inpage-nav-present");
        this.topBorder.style.top = `-${+this.headerHeight}px`;
        this.topBorderTopPosition =
            this.topBorder.getBoundingClientRect().top + root.scrollTop;
    },

    // To add active class
    setActiveClass(element, setClass) {
        if (element) {
            element.classList[setClass ? "add" : "remove"](
                this.activeClassName
            );
        }
    },

    // To observe if section with id is vissible in the viewport
    observerCallback(sections) {
        sections.forEach((section) => {
            if (section.isIntersecting) {
                const link = this.pageNavLinks.find(
                    (el) => el.hash === `#${section.target.id}`
                );

                this.pageNavLinks.forEach((el) =>
                    this.setActiveClass(el, false)
                );
                this.setActiveClass(link, true);
            }
        });
    },

    setObserver() {
        const observer = new IntersectionObserver(
            this.observerCallback.bind(this),
            { rootMargin: "-50% 0px" }
        );

        this.setcionsWithId.forEach((section) => observer.observe(section));
    },

    checkScroll() {
        const observer = new IntersectionObserver(
            ([e]) => {
                if (
                    e.intersectionRatio < 1 &&
                    window.innerHeight + root.scrollTop >
                        this.topBorderTopPosition
                ) {
                    this.header.classList.add("position-absolute");
                    this.header.style.top = `${+this.topBorderTopPosition}px`;
                    this.pageNavWrapper.classList.add("sticky");
                } else {
                    this.header.classList.remove("position-absolute");
                    this.header.style.top = 0;
                    this.pageNavWrapper.classList.remove("sticky");
                }
            },
            { threshold: [1] }
        );

        observer.observe(this.topBorder);
    },

    // To initialize whole script
    init() {
        if (
            !this.pageNavWrapper ||
            breakpoints.tabletMin.matches ||
            this.isInit
        ) {
            return;
        }
        this.isInit = true;
        this.cacheDOM();
        this.bindEventsListeners();
        this.stickyPosition();
        this.setObserver();
        this.checkScroll();
    },
};

export default pageNav;
